export const KEY_ACCESS_TOKEN = 'access_token';
export const KEY_LOGGED = 'logged';
export const KEY_REFRESH_TOKEN = 'refresh_token';
export const KEY_CURRENT_LOCAL_AUTHORITY = 'current_local_authority'; 


// WEBPACK FOOTER //
// ./src/util/storage.js